export const TAP_MOVEMENT_THRESHOLD_PX = 10;
export const TAP_DURATION_THRESHOLD_MS = 800;

function pointFromEvent(event = {}) {
  const source = event.nativeEvent || event;
  return {
    x: Number(source.clientX ?? source.pageX ?? 0),
    y: Number(source.clientY ?? source.pageY ?? 0),
    at: Number(source.timeStamp ?? Date.now()),
  };
}

export function createTapGestureTracker({
  movementThreshold = TAP_MOVEMENT_THRESHOLD_PX,
  durationThreshold = TAP_DURATION_THRESHOLD_MS,
} = {}) {
  let start = null;
  let maximumDistance = 0;

  return {
    start(event) {
      start = pointFromEvent(event);
      maximumDistance = 0;
    },
    move(event) {
      if (!start) return;
      const current = pointFromEvent(event);
      maximumDistance = Math.max(
        maximumDistance,
        Math.hypot(current.x - start.x, current.y - start.y)
      );
    },
    cancel() {
      start = null;
      maximumDistance = 0;
    },
    end(event) {
      if (!start) return false;
      const finish = pointFromEvent(event);
      const distance = Math.max(
        maximumDistance,
        Math.hypot(finish.x - start.x, finish.y - start.y)
      );
      const duration = Math.max(0, finish.at - start.at);
      start = null;
      maximumDistance = 0;
      return distance <= movementThreshold && duration <= durationThreshold;
    },
  };
}
